import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../alert.service';
import { ProposalService } from '../proposal.service';
import { NgIf } from '@angular/common';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { faSave } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-proposal-multi-agreement-type-options-modal',
  templateUrl: './proposal-multi-agreement-type-options-modal.component.html',
  styleUrls: ['./proposal-multi-agreement-type-options-modal.component.css'],
  imports: [ReactiveFormsModule]
})
export class ProposalMultiAgreementTypeOptionsModalComponent implements OnInit {

  // Properties
  @Input() private proposalId: string;
  @Input() private multiOptions: any;
  @Output() multiOptionsUpdated: EventEmitter<void> = new EventEmitter<void>();
  multiAgreementTypeForm: FormGroup;

  // Font Awesome Properties
  faSave = faSave;

  constructor(private proposalService: ProposalService,
    private alertService: AlertService,
    public modal: NgbActiveModal) { }

  ngOnInit(): void {
    this.multiAgreementTypeForm = new FormGroup({
      A: new FormGroup({
        isEnabled: new FormControl(false),
        numOfYears: new FormControl()
      }),
      B: new FormGroup({
        isEnabled: new FormControl(false),
        numOfYears: new FormControl()
      }),
      C: new FormGroup({
        isEnabled: new FormControl(false),
        numOfYears: new FormControl()
      }),
      D: new FormGroup({
        isEnabled: new FormControl(false),
        numOfYears: new FormControl()
      }),
      E: new FormGroup({
        isEnabled: new FormControl(false),
        numOfYears: new FormControl()
      })
    });
    if (this.multiOptions) this.prepareForm();
  }

  // Prepare Form
  private prepareForm(): void {
    const validMultiAgreementOptions: string[] = ['A', 'B', 'C', 'D', 'E'];
    for (const property in this.multiOptions) {
      if (!validMultiAgreementOptions.includes(property)) continue;
      (this.multiAgreementTypeForm.controls[property] as FormGroup).controls['isEnabled'].setValue(this.multiOptions[property].isEnabled);
      (this.multiAgreementTypeForm.controls[property] as FormGroup).controls['numOfYears'].setValue(this.multiOptions[property]?.numOfYears ?? null);
    }
  }

  // Update Proposal Multi Options
  updateProposalMultiOptions(): void {
    this.proposalService.updateProposalMultiOptions(this.proposalId, this.multiAgreementTypeForm.value).subscribe(() => {
      this.alertService.showSuccessAlert('Multi Options Updated');
      this.multiOptionsUpdated.emit();
      this.modal.close();
    });
  }
}
